import { actionFactory } from 'redux/factories';
import { types } from './types';

export const getSubcontractors = actionFactory(types.GET_SUBCONTRACTORS);
